import walletAuth from '@/auth/wallet/auth'
export default {
    namespaced: true,
    state: {
      token: null,
      user: null,
    },
    getters: {
      user: state => state.user||JSON.parse(localStorage.getItem(walletAuth.config.userData)),
      token: state => state.token||localStorage.getItem(walletAuth.config.userToken)
    },
    mutations: {
      account (state, userData) {
        if (!userData) return false

        if(userData.user) {
          localStorage.setItem(walletAuth.config.userData, JSON.stringify(userData.user))
          state.user = userData.user
        }

        if (userData.token) {
          localStorage.setItem(walletAuth.config.userToken, userData.token)
          state.token = userData.token
        }
      },
      clean (state) {
        localStorage.removeItem(walletAuth.config.userData)
        localStorage.removeItem(walletAuth.config.userToken)
        state.user = null
        state.token = null
      }
    }
  }